import { FormattedMessage } from 'react-intl';
import styles from './InfoBox.module.scss';
import { FeaturesService } from 'client/services';
import Button from 'client/components/aria/Button/Button';
import PdfIcon from 'client/components/aria/Icons/PdfIcon/PdfIcon';
import useAsync from 'client/utils/hooks/useAsync';
import Loading from 'client/components/ui/Loading/Loading';
import { MIME_TYPES, isInternalFile } from 'client/utils/helpers/LinkedFiles/LinkedFilesUtils';
import Link from 'client/components/aria/Link/Link';
import { prettifyUrl } from 'client/utils/helpers/UrlUtils/UrlsUtils';
import Icon from '@mdi/react';
import { mdiOpenInNew } from '@mdi/js';

const LinkedFile = ({ linkedFile, assetInfo }) => {
    const { assetType, assetTypeId } = assetInfo || {};

    const downloadAndOpen = async (linkedFileId, artefactTable, artefactId) => {
        const imageData = await FeaturesService.downloadLinkedFile(linkedFileId, artefactTable, artefactId);

        if (imageData) {
            const objectURL = URL.createObjectURL(imageData);
            window.open(objectURL, '_blank', 'noopener, noreferrer');
        } else {
            throw new Error('Failed to download file');
        }
    };

    const { isPending, error, execute } = useAsync(downloadAndOpen, false);
    if (isInternalFile(linkedFile)) {
        return <div key={linkedFile?.systemId} data-testid={linkedFile?.systemId + '.linkedFile'}>
            <Button
                variant='secondary'
                className={[isPending ? styles.loadingLinkedFile : styles.linkedFileButton].join(' ')}
                isDisabled={isPending}
                onPress={() => {
                    execute(linkedFile?.systemId, assetType, assetTypeId).catch(() => undefined);
                }}
            >
                {linkedFile?.name}
                {linkedFile.mimetype === MIME_TYPES.PDF && <PdfIcon />}
                {isPending && <div className={styles.spinner}>
                    <Loading variant='xs' />
                </div>
                }
            </Button>

            {error &&
                <div className="govuk-error-message">
                    <FormattedMessage id='supplementaryDataTab.linkedFile.error.text' />
                </div>
            }
        </div>;
    } else {
        return <>
            <Link
                data-testid={linkedFile?.systemId + '.linkedFile'}
                className={['govuk-link govuk-body-s govuk-!-margin-bottom-2', styles.guidanceLink].join(' ')}
                href={linkedFile?.fullpath}
                target='_blank'
                rel='noopener noreferrer nofollow'
            >
                {prettifyUrl(linkedFile?.fullpath, linkedFile?.name)}
                <Icon path={mdiOpenInNew} size={0.7} />
            </Link>
        </>;
    }
};

export default LinkedFile;
